<div>
    <div class="back-container" (click)="back()">
        <span nz-icon nzType="arrow-left" nzTheme="outline"></span><span>{{'termsConditionsEvaluation.back' | translate}}</span>
      </div>
      <div class="title-container">
        <p class="title">{{'termsConditionsActivation.text1' | translate}}</p>
      </div>
    <div class="condition-use" style="padding: 40px;">

      <p au-target-id="337">{{'termsConditionsActivation.text2' | translate}}</p>

      <p au-target-id="338">{{'termsConditionsActivation.text3' | translate}}</p>
      <p au-target-id="339">{{'termsConditionsActivation.text4' | translate}}</p>
      <p au-target-id="340">{{'termsConditionsActivation.text5' | translate}}</p>
      <p au-target-id="341">{{'termsConditionsActivation.text6' | translate}}</p>
      <p au-target-id="342">{{'termsConditionsActivation.text7' | translate}}</p>

      <p au-target-id="343">{{'termsConditionsActivation.text8' | translate}}</p>
      <p au-target-id="344">{{'termsConditionsActivation.text9' | translate}}</p>
      <p au-target-id="345">{{'termsConditionsActivation.text10' | translate}}</p>

      <p au-target-id="346">{{'termsConditionsActivation.text11' | translate}}</p>
      <p au-target-id="347">{{'termsConditionsActivation.text12' | translate}}</p>
      <p au-target-id="348">{{'termsConditionsActivation.text13' | translate}}</p>
      <p au-target-id="349">{{'termsConditionsActivation.text14' | translate}}</p>
      <p au-target-id="350">{{'termsConditionsActivation.text15' | translate}}</p>
      <p au-target-id="351">{{'termsConditionsActivation.text16' | translate}}</p>

      <p au-target-id="352">{{'termsConditionsActivation.text17' | translate}}</p>
      <p au-target-id="353">{{'termsConditionsActivation.text18' | translate}}</p>
      <p au-target-id="354">{{'termsConditionsActivation.text19' | translate}}</p>
      <p au-target-id="355">{{'termsConditionsActivation.text20' | translate}}</p>

      <p au-target-id="356">{{'termsConditionsActivation.text21' | translate}}</p>
      <p au-target-id="357">{{'termsConditionsActivation.text22' | translate}}</p>

      <p au-target-id="358">{{'termsConditionsActivation.text23' | translate}}</p>
      <p au-target-id="359">{{'termsConditionsActivation.text24' | translate}}</p>
      <p au-target-id="360">{{'termsConditionsActivation.text25' | translate}}</p>
      <p au-target-id="361">{{'termsConditionsActivation.text26' | translate}}</p>
      <p au-target-id="362">{{'termsConditionsActivation.text27' | translate}}</p>
      <p au-target-id="363">{{'termsConditionsActivation.text28' | translate}}</p>
      <p au-target-id="364">{{'termsConditionsActivation.text29' | translate}}</p>
      <p au-target-id="365">{{'termsConditionsActivation.text30' | translate}}</p>
      <p au-target-id="366">{{'termsConditionsActivation.text31' | translate}}</p>
      <p au-target-id="367">{{'termsConditionsActivation.text32' | translate}}</p>
      <p au-target-id="368">{{'termsConditionsActivation.text33' | translate}}</p>
      <p au-target-id="369">{{'termsConditionsActivation.text34' | translate}}</p>
      <p au-target-id="370">{{'termsConditionsActivation.text35' | translate}}</p>
      <p au-target-id="371">{{'termsConditionsActivation.text36' | translate}}</p>
      <p au-target-id="372">{{'termsConditionsActivation.text37' | translate}}</p>
      <p  au-target-id="373">{{'termsConditionsActivation.text38' | translate}}</p>
      <p au-target-id="374">{{'termsConditionsActivation.text39' | translate}} </p>
      <p au-target-id="375">{{'termsConditionsActivation.text40' | translate}}</p>
      <p au-target-id="376">{{'termsConditionsActivation.text41' | translate}}</p>
      <p au-target-id="377">{{'termsConditionsActivation.text42' | translate}}</p>
      <p  au-target-id="378">{{'termsConditionsActivation.text43' | translate}}</p>
      <p  au-target-id="379">{{'termsConditionsActivation.text44' | translate}}</p>
      <p au-target-id="380">{{'termsConditionsActivation.text45' | translate}}</p>
      <p au-target-id="381">{{'termsConditionsActivation.text46' | translate}}</p>
      <p  au-target-id="382">{{'termsConditionsActivation.text47' | translate}}</p>

      <p au-target-id="383">{{'termsConditionsActivation.text48' | translate}}</p>
      <p au-target-id="384">{{'termsConditionsActivation.text49' | translate}}</p>
      <p au-target-id="385">{{'termsConditionsActivation.text50' | translate}}</p>
      <p au-target-id="386">{{'termsConditionsActivation.text51' | translate}}</p>
      <p au-target-id="387">{{'termsConditionsActivation.text52' | translate}}</p>
      <p au-target-id="388">{{'termsConditionsActivation.text53' | translate}}</p>
      <p au-target-id="389">{{'termsConditionsActivation.text54' | translate}}</p>
      <p au-target-id="390">	{{'termsConditionsActivation.text55' | translate}}</p>

  </div>
</div>
